/* eslint-disable no-restricted-imports -- file uses shared helpers from auth-fe to parse data loader responses */
import { Authenticated, useAuth as useSharedAuth } from '@opendoor/auth-fe';

import { SystemError, UnauthenticatedError } from './Error';

/**
 * Helper to return the user regardless of auth state
 * @module platform/auth-fe
 * @returns {user | undefined} - The authenticated user
 * @throws {SystemError} - If the auth-fe query returns an error
 */
export const useAuth = () => {
  const { authentication, ...rest } = useSharedAuth();

  if (authentication.state === 'error') {
    throw new SystemError(authentication.message);
  }
  return { ...authentication, ...rest };
};

/**
 * Helper to return the authenticated user for auth-gatd routes
 * @module platform/auth-fe
 * @throws {SystemError} - If the user is not authenticated
 */
export const useAuthAuthenticated = (triggeredQuery?: string) => {
  const data = useAuth();
  if (data.state !== 'authenticated' || data.user === null || !data.user) {
    throw new UnauthenticatedError(triggeredQuery);
  }

  // Can be typecast because of above checks
  const auth = { user: data.user, state: data.state } as Authenticated;
  return { ...data, ...auth };
};
